(function($) {

	'use strict';

	var init = function() {

        $.each(items, function() {
            showOnScroll(this);
        });
    };

    var items = [$('.hp-engagements__bloc'), $('.hp-ref__image')];

    var showOnScroll = function(object) {
        $(window).scroll(function() {
            object.each(function(index) {
                var bottomOfObject = $(this).offset().top + $(this).outerHeight();
                var bottomOfWindow = $(window).scrollTop() + $(window).height();

                if(bottomOfWindow > bottomOfObject) {
                    $(this).css('animation-play-state', 'running');
                    $(this).css('animation-delay', index * 0.35 + 's');
                }
            });
        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);